export default {
  API_GET_REQUEST_PROVIDERS: "API_GET_REQUEST_PROVIDERS",
  API_GET_RECEIVE_PROVIDERS: "API_GET_RECEIVE_PROVIDERS",
  API_GET_ERROR_PROVIDERS: "API_GET_ERROR_PROVIDERS"
};
